export default function transform(serverTableData) {
  if (!serverTableData.page || serverTableData.page === undefined) {
    serverTableData.page = 1;
  }
  if (!serverTableData.limit || serverTableData.limit === undefined) {
    serverTableData.limit = 100;
  }
  const inputServer = {
    SkipCount: (serverTableData.page - 1) * serverTableData.limit,
    MaxResultCount: serverTableData.limit,
    Query: serverTableData.query,
    Inclusion: serverTableData.inclusion,
  };

  if (serverTableData.query) {
    Object.keys(serverTableData.query).forEach(key => {
      if (typeof serverTableData.query[key] === 'string') {
        serverTableData.query[key] = serverTableData.query[key].trim();
      }
    });
  }
  if (serverTableData.orderBy) {
    let order = ' ASC';
    if (!serverTableData.ascending) {
      order = ' DESC';
    }

    inputServer.Sorting = serverTableData.orderBy + order;
  }
  if (serverTableData.sorting) {
    inputServer.Sorting = serverTableData.sorting;
  }
  return inputServer;
}
